/**
 * main.js — NS Master theme
 */

document.addEventListener( 'DOMContentLoaded', () => {

	// ── AOS ───────────────────────────────────────────────────────────────────
	AOS.init( {
		duration: 700,
		easing:   'ease-out-quad',
		once:     true,
		offset:   80,
	} );

	// ── Odometer ──────────────────────────────────────────────────────────────
	const counters = document.querySelectorAll( '.odometer[data-count]' );

	if ( counters.length ) {
		const odometerObserver = new IntersectionObserver(
			( entries ) => {
				entries.forEach( ( entry ) => {
					if ( ! entry.isIntersecting ) return;

					const el    = entry.target;
					const od    = new Odometer( { el, value: 0 } );
					const count = parseInt( el.dataset.count, 10 );

					setTimeout( () => od.update( count ), 150 );
					odometerObserver.unobserve( el );
				} );
			},
			{ threshold: 0.35 }
		);

		counters.forEach( ( el ) => odometerObserver.observe( el ) );
	}

	// ── Splide — only for elements WITHOUT data-splide-managed ───────────────
	document.querySelectorAll( '.splide:not([data-splide-managed])' ).forEach( ( el ) => {
		new Splide( el ).mount();
	} );

	// ── Single Project — Lightbox ─────────────────────────────────────────────
	const projectArticle = document.querySelector( '.single-project' );

	if ( projectArticle ) {
		initSingleProjectLightbox( projectArticle );
	}

} );


/**
 * Lightbox for single-project pages.
 * Opens a full-screen overlay when any [data-lightbox] image is clicked.
 * Supports keyboard navigation (← → Esc) and prev/next buttons.
 *
 * @param {HTMLElement} article  The .single-project <article> element.
 */
function initSingleProjectLightbox( article ) {

	// ── Build ordered image list ──────────────────────────────────────────────
	const images = Array.from( article.querySelectorAll( 'img[data-lightbox]' ) );
	if ( ! images.length ) return;

	// ── Build lightbox DOM ────────────────────────────────────────────────────
	const overlay = document.createElement( 'div' );
	overlay.className  = 'sp-lightbox';
	overlay.setAttribute( 'role', 'dialog' );
	overlay.setAttribute( 'aria-modal', 'true' );
	overlay.setAttribute( 'aria-label', 'Image viewer' );

	overlay.innerHTML = `
		<button class="sp-lightbox__close" aria-label="Close image viewer">
			<svg width="28" height="28" viewBox="0 0 28 28" fill="none" aria-hidden="true">
				<path d="M21 7L7 21M7 7L21 21" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"/>
			</svg>
		</button>
		<button class="sp-lightbox__prev" aria-label="Previous image">
			<svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
				<path d="M13 4L7 10L13 16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
			</svg>
		</button>
		<div class="sp-lightbox__img-wrap">
			<img src="" alt="" />
		</div>
		<button class="sp-lightbox__next" aria-label="Next image">
			<svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
				<path d="M7 4L13 10L7 16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
			</svg>
		</button>
		<div class="sp-lightbox__counter" aria-live="polite"></div>
	`;

	document.body.appendChild( overlay );

	const lightboxImg = overlay.querySelector( '.sp-lightbox__img-wrap img' );
	const counter     = overlay.querySelector( '.sp-lightbox__counter' );
	const btnClose    = overlay.querySelector( '.sp-lightbox__close' );
	const btnPrev     = overlay.querySelector( '.sp-lightbox__prev' );
	const btnNext     = overlay.querySelector( '.sp-lightbox__next' );

	let currentIndex     = 0;
	let openedFromIndex  = 0;
	let savedScrollY     = 0;

	// ── Open / close helpers ──────────────────────────────────────────────────
	function openAt( index ) {
		const isAlreadyOpen = overlay.classList.contains( 'is-open' );

		currentIndex = ( index + images.length ) % images.length;
		const img    = images[ currentIndex ];

		lightboxImg.src     = img.src;
		lightboxImg.alt     = img.alt;
		counter.textContent = `${ currentIndex + 1 } / ${ images.length }`;

		// Hide prev/next when only one image
		btnPrev.hidden = btnNext.hidden = images.length < 2;

		// Solo aplicar el scroll lock la primera vez que se abre
		if ( ! isAlreadyOpen ) {
			openedFromIndex = currentIndex;
			savedScrollY    = window.scrollY;

			document.body.style.overflow = 'hidden';
			document.body.style.position = 'fixed';
			document.body.style.top      = `-${ savedScrollY }px`;
			document.body.style.width    = '100%';

			overlay.classList.add( 'is-open' );
			article.classList.add( 'lightbox-open' );
		}

		btnClose.focus();
	}

	function close() {
		overlay.classList.remove( 'is-open' );
		article.classList.remove( 'lightbox-open' );

		// Restore page scroll exactly where it was
		document.body.style.position = '';
		document.body.style.top      = '';
		document.body.style.width    = '';
		document.body.style.overflow = '';
		window.scrollTo( { top: savedScrollY, behavior: 'instant' } );

		// Return focus to the image that originally opened the lightbox
		images[ openedFromIndex ].focus();
	}

	// ── Trigger: click on any [data-lightbox] image ───────────────────────────
	images.forEach( ( img, i ) => {
		img.setAttribute( 'tabindex', '0' );
		img.setAttribute( 'role', 'button' );
		img.setAttribute( 'aria-haspopup', 'dialog' );

		img.addEventListener( 'click', () => openAt( i ) );
		img.addEventListener( 'keydown', ( e ) => {
			if ( e.key === 'Enter' || e.key === ' ' ) {
				e.preventDefault();
				openAt( i );
			}
		} );
	} );

	// ── Controls ──────────────────────────────────────────────────────────────
	btnClose.addEventListener( 'click', close );
	btnPrev.addEventListener(  'click', () => openAt( currentIndex - 1 ) );
	btnNext.addEventListener(  'click', () => openAt( currentIndex + 1 ) );

	// Click on backdrop (overlay itself, not children) closes
	overlay.addEventListener( 'click', ( e ) => {
		if ( e.target === overlay ) close();
	} );

	// Keyboard navigation
	document.addEventListener( 'keydown', ( e ) => {
		if ( ! overlay.classList.contains( 'is-open' ) ) return;

		if ( e.key === 'Escape' )     { close(); }
		if ( e.key === 'ArrowLeft' )  { openAt( currentIndex - 1 ); }
		if ( e.key === 'ArrowRight' ) { openAt( currentIndex + 1 ); }
	} );
}